import React from 'react';
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from '../redux/store';

type Props = {
  children: React.ReactNode,
  redirect?: string
}

const PublicRouteAdmin: React.FC<Props> = ({ children, redirect }) => {
  const ownerToken = useSelector((state: RootState) => state.owner.accessToken);
  const storeToken = useSelector((state: RootState) => state.store.accessToken);
  const adminToken = useSelector((state: RootState) => state.admin.accessToken);
  const organizerToken = useSelector((state: RootState) => state.organizer.accessToken);

  if (adminToken) return <Navigate to={redirect ? redirect : "/admin"} replace />;
  if (organizerToken) return <Navigate to={redirect ? redirect : "/organizer"} replace />;
  if (storeToken) return <Navigate to={redirect ? redirect : "/store/dashboard"} replace />;
  if (ownerToken) return <Navigate to={redirect ? redirect : "/owner"} replace />;


  return <>{children}</>;
}

export default PublicRouteAdmin;
